import { render, staticRenderFns } from "./TeamWizardComponent.vue?vue&type=template&id=6a83d012&"
import script from "./TeamWizardComponent.vue?vue&type=script&lang=js&"
export * from "./TeamWizardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports